import { formatSecondsAsTimer } from "@vericus/cadmus-common";
import { Alert } from "@vericus/cadmus-ui";

import { useCountdown } from "@/features/timeline";

import * as styles from "./reattempt-timer-tip.css";

// Under 2 min the countdown ticks per second (show M:SS); above it ticks per
// minute (show the human-friendly message).
const CLOCK_THRESHOLD_MS = 2 * 60 * 1000;

export function ReattemptTimerTip(props: {
  endDate: string;
  endDatePassed: boolean;
}) {
  const { message, milliseconds } = useCountdown(props.endDate);

  const remaining =
    milliseconds < CLOCK_THRESHOLD_MS
      ? formatSecondsAsTimer(Math.max(0, Math.round(milliseconds / 1000)))
      : message;

  return (
    <div className={styles.container}>
      {!props.endDatePassed && (
        <Alert severity="warning" size="sm">
          Your re-attempts will expire in {remaining}
        </Alert>
      )}
      {props.endDatePassed && (
        <Alert severity="error" size="sm">
          <div>Your re-attempt window has expired.</div>
          <div>Please contact your instructor if you have any questions.</div>
        </Alert>
      )}
    </div>
  );
}
